import { sheetDefinition, k5SpellColumns, displayRefusal } from './k5-runtime';
import { generateAbilityButton } from './ability-button';
import { abilityEffectButton } from './tabs/ability-effect-button';
import { decodeHtmlEntitiesForPlainText } from '../shared/decode-html-entities';
import { uuidOf, abilityInfoAttrs } from './tabs/ability-row';
import type { CachedCaster } from './types';

export async function ftCreatureAbilityChoicePayload(input: Record<string, unknown>): Promise<Record<string, unknown>> {
    try {
        const casterId = String(input.caster_id ?? '');
        const caster = window.FateTide?.casterCache?.get(casterId) as CachedCaster | undefined;
        if (!caster) throw new Error('unported:ability-choice:caster-not-held');
        const parent = sheetDefinition(caster, String(input.parent_ability_id ?? ''));
        const childId = String(input.ability_choice_item_id ?? '');
        if (!/^[\da-f]{8}(?:-[\da-f]{4}){3}-[\da-f]{12}$/i.test(childId)) throw new Error('unported:ability-choice:invalid-child-id');
        if (!ftLayerEntries(parent, 'ability_choice').some(entry => uuidOf(entry).toUpperCase() === childId.toUpperCase())) {
            throw new Error('unported:ability-choice:child-not-listed');
        }
        // Definitions are ordinary object reads, never a PHP rendering request.
        let child;
        try { child = sheetDefinition(caster, childId); }
        catch {
            await window.fetchAndCacheObject?.(childId);
            child = sheetDefinition(caster, childId);
        }
        const readonly = !ftHasPlayerPermission(caster);
        const columns = input.extend_spell_columns ? k5SpellColumns(child) : {};
        return { ok: true,
            html_button: generateAbilityButton(child, caster, { spellType: String(input.spell_type ?? '') || undefined,
                source: String(input.source ?? '') || undefined, consumeNestedUnitPerUse: Boolean(input.consume_nested_unit_per_use), buttonDisabled: readonly }),
            html_name_block: `<span class="link-primary" role="button" ${abilityInfoAttrs(childId)} data-ft-info-item-id="${escapeHtml(childId)}">${escapeHtml(decodeHtmlEntitiesForPlainText(String(ftItemsCol(child, 'item_name') ?? '')))}</span>`,
            html_effect: abilityEffectButton(caster, child, childId, readonly),
            html_cast_time: columns.cast_time, html_td_range: columns.range, html_td_aoe: columns.aoe,
            html_td_duration: columns.duration, html_td_hit_dc: columns.hit_dc };
    } catch (error) { return { ok: true, html_button: displayRefusal(error) }; }
}

Object.assign(window, { ftCreatureAbilityChoicePayload });
